// @ts-nocheck
import * as React from 'react';
import styled from 'styled-components';
import { baseDark } from 'crehana-ui/styles/colors';
import Media from 'Shared/ui/Media';
import getImgxUrl from 'crehana-utils/getImgxUrl';

const Overlay = styled.div`
  background: linear-gradient(
      180deg,
      rgba(15, 17, 36, 0) 88.3%,
      ${baseDark} 100%
    ),
    radial-gradient(
      68.69% 283.7% at 93.68% 31.31%,
      rgba(15, 17, 36, 0) 0%,
      ${baseDark} 100%
    );
`;

type BackgroundProps = {
  backgroundImage: {
    webp: string;
    jpg: string;
  };
};

const Background: React.FC<BackgroundProps> = ({ backgroundImage }) => {
  return (
    <div className="z-5">
      <Media from="md" defaultMatches={false}>
        <picture className="block absolute inset-0 overflow-hidden bg-base-dark">
          <source
            media="(max-width: 1024px)"
            srcSet={getImgxUrl(backgroundImage.webp, {
              fm: 'webp',
            })}
            type="image/webp"
          />
          <img
            src={getImgxUrl(backgroundImage.jpg, {
              fm: 'jpg',
            })}
            alt="cover"
            css={`
              object-position: right;
            `}
            className="h-full w-full object-cover"
          />
        </picture>
      </Media>
      {/* Overlay */}
      <Overlay className="absolute h-full w-full top-0 left-0 hidden md:block" />
    </div>
  );
};

export default Background;
